import { DealStep } from "@/types"
import axios from "../axiosInstance"

export const getClientDeals = async () => {
  try {
    const res = await axios.get(`/deals/client`)
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to fetch deals")
    }
    
    return data.deals
  } catch (error) {
    console.error("Error fetching deals:", error)
    throw error
  }
}

export const getRecentDealCount = async () => {
  try {
    const res = await axios.get("/deals/data")
    const { data } = res
    return data.dealData
  } catch (error) {
    console.error("Error fetching recent deal count:", error)
    throw error
  }
}

export const getDealTrends = async () => {
  try {
    const res = await axios.get("/deals/trends")
    const { data } = res
    return data.dealData
  } catch (error) {
    console.error("Error fetching recent deal count:", error)
    throw error
  }
}

export const getDealsGroupedByCompanies = async () => {
  try {
    const res = await axios.get(`/deals/company/count`)
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to fetch deals grouped by companies")
    }
    return data.dealData
  } catch (error) {
    console.error("Error fetching deals grouped by companies:", error)
    throw error
  }
}

export const getValidatedClientDeals = async (clientId: number) => {
  try {
    const res = await axios.get(`/deals/client/${clientId}/validate`)
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to fetch validated deals")
    }
    return data.deals
  } catch (error) {
    console.error("Error fetching validated deals:", error)
    throw error
  }
}

export const getDealManagerDeals = async () => {
  try {
    const res = await axios.get("/deals/deal-manager")
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to fetch deal manager deals")
    }
    return data.deals
  } catch (error) {
    console.error("Error fetching deal manager deals:", error)
    throw error
  }
}

export const updateDealCurrentStep = async (dealId: number, step: DealStep) => {
  try {
    const res = await axios.post(`/deals/step/update`, { step, dealId })
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to update deal current step")
    }
    return data.deal
  } catch (error) {
    console.error("Error updating deal current step:", error)
    throw error
  }
}